// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FdfyBT6dQZMPQ3TM{border-radius:1000px}.L1Nq1l5UcrMSd56w{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;display:block}.HGPtOyTUBkQhb1gl{display:flex;flex-direction:column;justify-content:center;align-items:center}.IO0j4mn1stct9Ugs{animation:bAAhZxfvMiYRDHqM 3s infinite;animation-iteration-count:infinite}@keyframes bAAhZxfvMiYRDHqM{0%{background:var(--py-neutral-1)}30%{background:var(--py-neutral-1)}50%{background:var(--py-neutral-1)}80%{background:var(--py-neutral-1)}100%{background:var(--py-neutral-1)}}.eXxtKQIYfkQLwfR4{min-width:100%;margin-top:8px}.HVd0npeisqkgsZpL{transform-origin:var(--radix-popover-content-transform-origin);animation:IFrxvLctLCInMdMr .5s ease-out;width:var(--radix-popover-trigger-width);height:var(--radix-popover-content-available-height)}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"circle": `FdfyBT6dQZMPQ3TM`,
	"text-truncate": `L1Nq1l5UcrMSd56w`,
	"shaquille": `HGPtOyTUBkQhb1gl`,
	"shimmer": `IO0j4mn1stct9Ugs`,
	"placeHolderShimmer": `bAAhZxfvMiYRDHqM`,
	"dismissButton": `eXxtKQIYfkQLwfR4`,
	"PopoverContent": `HVd0npeisqkgsZpL`,
	"scaleIn": `IFrxvLctLCInMdMr`
};
export default ___CSS_LOADER_EXPORT___;
